import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { searchAssets } from "signoxe/actions";
import { AssetDraggable } from "signoxe/components";
import { Box } from "signoxe/components/layout";
import { Icon } from "signoxe/components/widgets";
import { getCampaigns } from "signoxe/selectors/campaigns";
import { AssetPropType } from "../../constants/propTypes";
import {
  getFilteredAssets,
  getFilteredAssetsByCampaign,
} from "../../selectors";
import CampaignDraggable from "../CampaignDraggable";
import { Button } from "../widgets";
import "./styles.scss";

class AssetDND extends Component {
  constructor(props) {
    super(props);

    this.state = { 
      searchTerm: ""
    
    };
  }

  static propTypes = {
    assets: PropTypes.arrayOf(AssetPropType),
    searchAssets: PropTypes.func.isRequired,
    onDoubleTapAsset: PropTypes.func.isRequired,
    onBulkAddAssets: PropTypes.func.isRequired,
    replaceAddItems: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onCampaignClick: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
  };

  handleBulkAdd = () => {
    
    this.props.onBulkAddAssets(
    
      // Filter all the keys that have a true value
      Object.keys(this.state).filter((key) => this.state[key])
    );

    this.props.onClose();
  };
  
  handleReplaceItems = () => {
    
    this.props.replaceAddItems(
    
      // Filter all the keys that have a true value
      Object.keys(this.state).filter((key) => this.state[key])
    );

    this.props.onClose();
  };


  checkMultipleSelected = () => {
    const assests =  Object.keys(this.state).filter((key) => this.state[key])
    if (assests.length > 1){
      return true
    }else if (assests.length == 0){
      return true
    }
    else{
      return false
    }


  }
 

  handleSearch = (event) => {
    console.log("handleSearch state = ", this.props.state);
    this.setState({ searchTerm: event.target.value });
    this.props.searchAssets(event.target.value);
  };

  handleSelectAsset = (asset) => {
    this.setState({ [asset.id]: !this.state[asset.id] });
  };

  componentDidMount() {
    this.props.searchAssets(""); // Clear any existing search query
  }

  ifItemsSelected() {
    return Object.values(this.state).some((val) => val);
  }

  render() {
    const { isCampaignClicked, is_maker_checker } = this.props;
    const { searchTerm } = this.state;
    console.log("playlist is_maker_checker", is_maker_checker)
    return (
      <Box
        className="assets-dnd-container"
        direction="column"
        alignItems="stretch"
      >
        <div className="input-group">
          <input
            className="input-group-field"
            type="text"
            placeholder="Search assets"
            onChange={this.handleSearch}
          />
          <span className="input-group-label">
            <Icon title="Search" name="search" size="1rem" />
          </span>
        </div>
        <Box direction="row" justifyContent="space-between" className="hide-for-mobile">
          { this.props.replacing == false && <Button   onClick={this.ifItemsSelected && this.handleBulkAdd}>
            Add Selected to Playlist
          </Button>}
          { this.props.replacing == true && <Button
          isDisabled={this.checkMultipleSelected()}
          onClick={this.ifItemsSelected && this.handleReplaceItems}>
           Replace Selected Items
          </Button>}
          {this.props.isCampaignClicked && (
            <Button secondary onClick={this.props.onBack}>
              GO Back
            </Button>
          )}

          <Button secondary onClick={this.props.onClose}>
            Close
          </Button>
        </Box>

        <Box direction="row" justifyContent="space-between" className="hide-for-desktop">
          {this.props.replacing  == false && <Button  className="font-size-sm" onClick={this.ifItemsSelected && this.handleBulkAdd}>
            Add Selected to Playlist
          </Button>}

          {this.props.replacing == true && <Button
          isDisabled={this.checkMultipleSelected()}
          className="font-size-sm" onClick={this.ifItemsSelected && this.handleReplaceItems}>
          Replace Selected Items
          </Button>}
          {this.props.isCampaignClicked && (
            <Button className="font-size-sm" secondary onClick={this.props.onBack}>
              GO Back
            </Button>
          )}

          <Button className="font-size-sm"  secondary onClick={this.props.onClose}>
            Close
          </Button>
        </Box>
        <Box
          wrap
          className="assets-list"
          direction="row"
          alignItems="flex-start"
        >
          {!isCampaignClicked &&
            searchTerm === "" &&
            this.props.campaigns.map((campaign) => (
              <CampaignDraggable
                key={campaign.id}
                asset={campaign}
                // onTap={this.handleSelectAsset}
                selected={this.state[campaign.id]}
                onCampaignClick={this.props.onCampaignClick}
                onBack={this.props.onBack}
              />
            ))}
          {!isCampaignClicked &&
            searchTerm === "" &&
            this.props.leafFiles
            .filter(asset => {
              if (this.props.is_maker_checker) {
                return asset.status === "approved";
              }
              return true; // Include all assets when is_maker_checker is false
            })
            .map((asset) => (
              <AssetDraggable
                key={asset.id}
                asset={asset}
                onTap={this.handleSelectAsset}
                selected={this.state[asset.id]}
              />
            ))}
          {!isCampaignClicked &&
            searchTerm !== "" &&
            this.props.assets
            .filter(asset => {
              if (this.props.is_maker_checker) {
                return asset.status === "approved";
              }
              return true; // Include all assets when is_maker_checker is false
            })
            .map((asset) => (
              <AssetDraggable
                key={asset.id}
                asset={asset}
                onTap={this.handleSelectAsset}
                selected={this.state[asset.id]}
              />
            ))}
          {isCampaignClicked &&
            this.props.campaignAssets
            .filter(asset => {
              if (this.props.is_maker_checker) {
                return asset.status === "approved";
              }
              return true; // Include all assets when is_maker_checker is false
            })
            .map((asset) => (
              <AssetDraggable
                key={asset.id}
                asset={asset}
                onTap={this.handleSelectAsset}
                selected={this.state[asset.id]}
              />
            ))}
        </Box>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    state,
    assets: getFilteredAssets(state),
    campaigns: getCampaigns(state),
    leafFiles: getFilteredAssetsByCampaign(state, ""),
  }),
  { searchAssets, getFilteredAssetsByCampaign }
)(AssetDND);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetDND/index.js